<template>

  <vs-table :data="timecardList">

    <template slot="thead">
      <vs-th :key="i" class="text-base" v-for="(title, i) in header"
             :class="{'float-right': title === $t('timecards.table.actions')}">{{ title }}
      </vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indexTr" v-for="(tr, indexTr) in data">
        <vs-td :data="tr.project.name">
          {{ tr.project.client.name }} - {{ tr.project.name }}
        </vs-td>
        <vs-td :data="tr.date">
          {{ tr.date | fromShortDate('MMM Do YYYY') }}
        </vs-td>
        <vs-td :data="tr.start_time">
          {{ tr.start_time | time }}
        </vs-td>
        <vs-td :data="tr.end_time">
          {{ tr.end_time | time}}
        </vs-td>
        <vs-td :data="tr.notes" class="max-w-xs truncate">
          {{ tr.notes }}
        </vs-td>
        <vs-td class="text-right w-16">
          <div class="flex justify-end">
            <vx-tooltip :text="$t('buttons.details')" position="top">
              <base-button @click="$emit('details', tr)" class="self-end mx-px" icon="info"></base-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('buttons.delete')" position="top">
              <base-button :loading="isUpdating(tr.id)" @click="$emit('delete', tr)" class="self-end mx-px"
                           color="danger" icon="trash"></base-button>
            </vx-tooltip>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
  export default {
    name:"TimeCardTable",
    props:{
      header:{
        type:Array,
        required:true
      },
      timecardList:{
        type:Array,
        required:true
      },
      updatingTimecards:{
        type:Array,
        required:true
      }
    },
    data:() => ({
      selectedEntries:[]
    }),
    methods:{
      isUpdating(id) {
        return this.updatingTimecards.indexOf(id) > -1
      },
    },
  }
</script>

<style scoped>

</style>
